module.exports = __webpack_public_path__ + "static/media/nino-hover.613e9b22.png";